import {
    buildProductListing,
    buildRelevanceSortCriterion,
    buildFieldsSortCriterion
} from '@coveo/headless/commerce'

import { getProductListUrl } from '../utils/searchUtils';
import { productListingEngine as engine } from '../PLPEngine';

var productListingController;

const getProductListingUrl = () => {
    let url = 'https://www.sunbeltrentals.com';
    if (window.location.pathname.includes('equipment-rental/')) {
        url += getProductListUrl();
    } else {
        url =
            'https://www.sunbeltrentals.com/equipment-rental/aerial-work-platforms-scaffolding-and-ladders/electric-scissorlifts/';
    }
    sessionStorage.setItem("listingReqUrl", url)
    return url;
};

const urlParams = new URLSearchParams(window.location.search);
const requestedPage = Number(urlParams.get("page")) || 1;
const maxPage = sessionStorage.getItem('plpMaxPage'); // Set this dynamically if needed
const currentPage = requestedPage < 1 || requestedPage > maxPage ? 1 : requestedPage;

const productListingProps = {
    options: {
        url: getProductListingUrl(),
        additionalFields: [
            'categoryl2',
            'categoryl3',
            'productcatsortindex',
            'ec_primary_image',
            'ec_skus',
            'ec_product_url',
            'ec_show_onlinecatalog',
            'ec_disable_addtocartoption',
            'source',
            'ec_category',
            'ec_category_id',
            'ec_pc_inventory',
            'ec_meta_title',
            'ec_meta_description',
            'ec_specialtytypes',
            'ec_specialtytypecode',
            'ec_analysisgroupcode',
            'ec_specifications',
            'ec_isgreenleaf',
            'ec_greenleafdata',
            'ec_accessoriesaddons'
        ]
    }
};

const pagerProps = {
    initialState: {
        page: currentPage  // Set currentPage as initial state
    },
    options: {
        numberOfPages: 5
    }
};

const resultsPagerProps = {
    initialState: {
        numberOfResults: 50
    }
};

productListingController = buildProductListing(engine);

var relevanceSortCriterion = buildRelevanceSortCriterion();
var nameSortAsc = buildFieldsSortCriterion([{ name: 'ec_name', direction: 'asc' }]);
var nameSortDesc = buildFieldsSortCriterion([{ name: 'ec_name', direction: 'desc' }]);

var categoryLevel = document.querySelector("meta[name='categoryLevel']")?.content;
//listing calls removed from other pages except plp
if (categoryLevel) {
    // productListingController.refresh();
}

export {
    productListingController,
    relevanceSortCriterion,
    nameSortAsc,
    nameSortDesc,
};
